import { PayloadAction } from '@reduxjs/toolkit';

import { PreviewState, PreviewStatus } from 'editor/src/store/editorModules/preview/types';

const setPreviewStatusReducer = (state: PreviewState, action: PayloadAction<PreviewStatus>) => {
  state.status = action.payload;
};

export default setPreviewStatusReducer;
